import { httpService } from "./httpService";

export const paymentService = {
    
    stripeSetupIntent() {
        return httpService.getRequest<any>(`billing/subscribe/stripe/setup-intent`)
    },
    
    stripeSubscribe(formData: object) {
        return httpService.postRequest<any, any>(`billing/subscribe/stripe`, formData)
    },

    stripeSubscribeConfirmed(formData: object) {
        return httpService.postRequest<any, any>(`billing/subscribe/stripe/confirmed`, formData)
    },
}